
import { supabase } from '@/integrations/supabase/client';

/**
 * Redirect a user to the Chat App with authentication
 */
export const redirectToChatApp = async (userEmail: string, userPassword: string) => {
  try {
    // Get auth session after signup
    const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError) {
      console.error("Error getting session:", sessionError);
      window.open('https://chat.krix.app', '_blank');
      return;
    }
    
    if (sessionData?.session?.access_token) {
      // Redirect with token if we have a session
      const redirectUrl = `https://chat.krix.app?token=${encodeURIComponent(sessionData.session.access_token)}`;
      console.log(`Redirecting to ${redirectUrl}`);
      window.location.href = redirectUrl;
    } else {
      // Try to sign in to get a token
      const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
        email: userEmail,
        password: userPassword
      });
      
      if (signInError) {
        console.error("Error signing in:", signInError);
        window.open('https://chat.krix.app', '_blank');
        return;
      }
      
      if (signInData?.session?.access_token) {
        const redirectUrl = `https://chat.krix.app?token=${encodeURIComponent(signInData.session.access_token)}`;
        console.log(`Redirecting to ${redirectUrl} after sign in`);
        window.location.href = redirectUrl;
      } else {
        window.open('https://chat.krix.app', '_blank');
      }
    }
  } catch (error) {
    console.error("Error in redirectToChatApp:", error);
    window.open('https://chat.krix.app', '_blank');
  }
};
